import { StackProps } from '@mantine/core';
import { RapidModel } from '../../../../types/rapidModel';
import { RawModel } from '../../../../types/rawModel';
import { RawModelMetadata } from '../atoms/RawModelMetadata';
import { OutputMetadata } from '../atoms/OutputModelMetadata';

type MetadataProps = { asset: RawModel | RapidModel } & StackProps;

export const Metadata = ({ asset, ...stackProps }: MetadataProps) => {
  if (asset.assetType !== 'raw') {
    return <OutputMetadata outputModel={asset} maw={stackProps.maw} />;
  }

  return <RawModelMetadata asset={asset} {...stackProps} />;
};
